<app-file-upload-button (fileUploaded)="fileUploaded($event)" [acceptMultipleFiles]="false"></app-file-upload-button>
<button (click)="startSigning()">Start Signing</button>
<div *ngIf="embeddedSigningUrl">
  <a [href]="embeddedSigningUrl" download="signed-document.pdf">Download Signed Document</a>
</div>
